export const INVENTORY_HISTORY_DISPLAY_LIMIT = 8;
